import React from 'react';

const AboutSection = ({ t }) => {
  return (
    <section id="about" className="py-20 bg-[#F5F3F0]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2
            className="text-4xl sm:text-5xl font-light text-[#2C2C2C] mb-8"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            {t.aboutSection.title}
          </h2>
          <div className="w-24 h-1 bg-[#C4B5A0] mx-auto mb-8"></div>
          <p className="text-lg text-[#2C2C2C] leading-relaxed">
            {t.aboutSection.text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
